import axios from 'axios';

export const axiosApi = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}/api/v1/`,
  headers: {
    common: {
      Authorization: localStorage.getItem('Bench-Auth-Token'),
    },
  },
});

export function injectAuthInterceptor(logoutCallback, redirectCallback) {
  axiosApi.interceptors.response.use(undefined, (error) => {
    if (error.response.status === 401) {
      logoutCallback();
    } else if (error.response.status === 403) {
      redirectCallback();
    } else {
      throw error;
    }
  });
}

export function authorizeAxios(token) {
  axiosApi.defaults.headers.common.Authorization = token;
}

export function deauthorizeAxios() {
  delete axiosApi.defaults.headers.common.Authorization;
}
